import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import { getNodeDataDefinition } from '../elements'
import type { Manager } from '../manager'

export const saveEditsToCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.saveEdits.observe().pipe(
      rxjsUtils.latestFrom(({ data: { orgChartId } }) => ({
        nodes: feature.selectors.getNodes({ orgChartId }).asObservable,
        orgChartId: rxjs.of(orgChartId),
      })),
      rxjs.map(({ nodes, orgChartId }) => {
        const cy = manager.getInstance({ orgChartId })
        if (!cy || !nodes.length) {
          return
        }
        // Writes the data of all nodes because we don't know which one(s) were
        // edited
        for (const node of nodes) {
          cy.getElementById(node.id).data(getNodeDataDefinition(node))
        }
      }),
      rxjs.ignoreElements(),
    ),
)
